import { createRouter, createWebHistory } from "vue-router";


// Master/Admin Views
import AdminLoginView from "../views/admin/AdminLoginView.vue";
// import TenantsView from "../views/admin/TenantsView.vue";


// Tenant Views
import HomeView from "../views/HomeView.vue";
import ConversationsView from "../views/ConversationsView.vue";
import ConversationView from "../views/ConversationView.vue";
import TemplatesView from "../views/TemplatesView.vue";
import TemplatesStatusView from "../views/TemplatesStatusView.vue";
import LoginView from "../views/auth/LoginView.vue";
import HomeSettingView from "../views/settings/HomeSettingView.vue";
import UsersSettingView from "../views/settings/UsersSettingView.vue";
// import CampaignsSettingView from "../views/settings/CampaignsSettingView.vue";

import WellcomeMessageSettingView from "../views/settings/WellcomeMessageSettingView.vue";
import EventAutoMessageSettingView from "../views/settings/EventAutoMessageSettingView.vue";
import ImageTemplateMessageView from "../views/settings/ImageTemplateMessageView.vue";
import TemplateAssetsView from "../views/settings/TemplateAssetsView.vue";
import BlackListView from "../views/settings/BlackListView.vue"
import DonationView from "../views/DonationView.vue";






import middleware from "./middleware";

const routes = [
  // ----------------------
  // MASTER / ADMIN ROUTES
  // ----------------------
  {
    path: "/admin/login",
    name: "admin-login",
    component: AdminLoginView,
    beforeEnter: middleware.masterGuest,
  },
 

  {
    path: "/admin/tenants",
    name: "tenants-list",
    component: () => import("../views/admin/TenantsListView.vue"),
    beforeEnter: middleware.masterAuth,

  },
  {
    path: "/admin/tenants/create",
    name: "tenants-create",
    component: () => import("../views/admin/TenantCreateView.vue"),
    beforeEnter: middleware.masterAuth,

  },
  {
    path: "/admin/tenants/:id/edit",
    name: "tenants-edit",
    component: () => import("../views/admin/TenantEditView.vue"),
    beforeEnter: middleware.masterAuth,

  },
  {
    path: "/admin/tenants/:id/settings",
    name: "tenants-settings",
    component: () => import("../views/admin/TenantSettingsView.vue"),
    beforeEnter: middleware.masterAuth,

  },

  // ----------------------
  // TENANT ROUTES
  // ----------------------
  {
    path: "/login",
    name: "login",
    component: LoginView, // replace with actual tenant login
    beforeEnter: middleware.guest,
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
    beforeEnter: middleware.auth,
  },
  {
    path: "/conversations",
    name: "conversations",
    component: ConversationsView,
    beforeEnter: middleware.auth,
    children: [
      {
        path: ":id",
        name: "conversation",
        component: ConversationView,
      },
      { path: "/:pathMatch(.*)*", redirect: "/conversations" },
    ],
  },
  {
    path: "/templates",
    name: "templates",
    component: TemplatesView,
    beforeEnter: middleware.auth,
  },
  {
    path: "/templates-statistics",
    name: "templatesStatistics",
    component: TemplatesStatusView,
    beforeEnter: middleware.auth,
  },
  {
    path: "/donations",
    name: "donations",
    component: DonationView,
    beforeEnter: middleware.auth,
  },
  {
    path: "/settings",
    name: "settings",
    component: HomeSettingView,
    beforeEnter: middleware.auth,
    children: [
      { path: "users-setting", name: "users-setting", component: UsersSettingView },
      { path: "black-list-setting", name: "black-list-setting", component: BlackListView },
      { path: "wellcome-message-setting", name: "wellcome-message-setting", component: WellcomeMessageSettingView },
      { path: "auto-message-setting", name: "auto-message-setting", component: EventAutoMessageSettingView },
      { path: "image-template-setting", name: "image-template-setting", component: ImageTemplateMessageView },
      { path: "template-assets-setting", name: "template-assets-setting", component: TemplateAssetsView },
      { path: "/:pathMatch(.*)*", redirect: "users-setting" },
    ],
  },

  // Fallback
  { path: "/:pathMatch(.*)*", redirect: { name: "home" } },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
});

export default router;
